module.exports = __webpack_public_path__ + "unallocated-icon.png?e67e1bcb7009b4e89477b723740b28a9";